export default __webpack_public_path__ + "static/media/david-headshot.16ed6bc0.png";